import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gunmetal-50 border-t border-onyx-400">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/triumph-logo-header.png"
                alt="Triumph Basketball"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white/50 text-sm font-body leading-relaxed max-w-xs">
              Dallas&apos;s premier youth basketball club. Est. 2007 · Dallas, Texas.
              Official Under Armour Program. Player development, discipline, through high level coaching.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white text-sm font-semibold tracking-wider uppercase mb-4">
              Navigate
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: "Home", path: "/" },
                { label: "Practices", path: "/practices" },
                { label: "Programs", path: "/programs" },
                { label: "TOOLS", path: "/tools" },
                { label: "Former Players", path: "/former-players" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/50 hover:text-strike-500 text-sm font-body transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-white text-sm font-semibold tracking-wider uppercase mb-4">
              Contact
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-onyx-300">
                  <i className="ri-phone-line text-strike-500 text-sm"></i>
                </div>
                <a
                  href="tel:+14699991911"
                  className="text-white/70 text-sm font-body hover:text-strike-500 transition-colors"
                >
                  469-999-1911
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-onyx-300">
                  <i className="ri-mail-line text-strike-500 text-sm"></i>
                </div>
                <a
                  href="mailto:contact@triumphbasketball.com"
                  className="text-white/70 text-sm font-body hover:text-strike-500 transition-colors"
                >
                  contact@triumphbasketball.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-onyx-300">
                  <i className="ri-map-pin-line text-strike-500 text-sm"></i>
                </div>
                <span className="text-white/70 text-sm font-body">
                  Dallas, Texas
                </span>
              </li>
            </ul>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.instagram.com/triumphuatx/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-onyx-300 hover:bg-strike-500 text-white/60 hover:text-onyx-50 transition-all"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-onyx-400 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs font-body">
            &copy; {new Date().getFullYear()} Triumph Basketball. All rights
            reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://app.triumphbasketball.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-strike-500 text-xs font-body transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="https://app.triumphbasketball.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-strike-500 text-xs font-body transition-colors"
            >
              Terms of Service
            </a>
          </div>
          <p className="text-white/30 text-xs font-body">
            Est. 2007 · Dallas, Texas
          </p>
        </div>
      </div>
    </footer>
  );
}